import React, { useState, useEffect, Suspense } from 'react';
import './Contacto.css';
import PageFooter from '../components/PageFooter';

// Lazy load components
const LazyPageBanner = React.lazy(() => import('../components/PageBanner'));
const LazyContactForm = React.lazy(() => import('../components/Contacto/ContactForm'));
const LazyContactCard = React.lazy(() => import('../components/Contacto/ContactCard'));
const LazyContactMap = React.lazy(() => import('../components/Contacto/ContactMap'));

const Contacto = () => {
  const [selectedOficina, setSelectedOficina] = useState(null);

  // Scroll to the top when the component is mounted
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Function to update the selected office
  const handleOfficeChange = (oficina) => {
    setSelectedOficina(oficina);
  };

  return (
    <div className="contact-page">
      <div className="contact-page-banner">
        {/* Lazy load the PageBanner */}
        <Suspense fallback={<div>Loading Banner...</div>}>
          <LazyPageBanner />
        </Suspense>
      </div>
      <div className="contact-page-content">
        <div className="contact-page-information">
          <div className="contact-page-card">
            {/* Lazy load the ContactCard */}
            <Suspense fallback={<div>Loading Contact Card...</div>}>
              <LazyContactCard onOfficeChange={handleOfficeChange} />
            </Suspense>
          </div>
          <div className="contact-page-form">
            {/* Lazy load the ContactForm */}
            <Suspense fallback={<div>Loading Contact Form...</div>}>
              <LazyContactForm selectedOficina={selectedOficina} />
            </Suspense>
          </div>
        </div>
      </div>
      <div className="contact-page-map">
        {/* Lazy load the ContactMap */}
        <Suspense fallback={<div>Loading Map...</div>}>
          <LazyContactMap oficina={selectedOficina} />
        </Suspense>
      </div>
      <div className="contact-page-footer">
        <PageFooter />
      </div>
    </div>
  );
};

export default Contacto;
